import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Form } from 'react-bootstrap';

import PasswordInput from '../../../components/PasswordInput';
import errorHandler from '../../Common/ErrorHandler';
import { login } from '../AuthActions';
import Testimonial from '../copmpnents/Testimonial/Testimonial.js';

import logo from './img/logo-nave-icon.svg';

// Import Style
import '../Auth.scss';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      rememberMe: false,
    };
  }

  handleChange = (ev) => {
    this.setState({
      [ev.target.name]: ev.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.email) {
      this.props.setError({
        data: {
          email: {
            msg: 'error.email.empty',
          },
        },
      });
      return false;
    }

    if (!this.state.password) {
      this.props.setError({
        data: {
          password: {
            msg: 'error.password.empty',
          },
        },
      });
      return false;
    }

    this.props.login(
      {
        email: this.state.email,
        password: this.state.password,
      },
      this.state.rememberMe
    );
  };

  render() {
    return (
      <div className='login_bg'>
        <div className='login_form'>
          <div className='logo'>
            <img src={logo} alt="" />
          </div>
          <div className='login_content'>
            <div className='left_part'>
              <h1> Partner Portal</h1>

              <Form className='form' noValidate onSubmit={this.handleSubmit}>
                <Form.Group>
                  <Form.Label htmlFor="email">Email</Form.Label>
                  <Form.Control
                    autoFocus
                    placeholder="Email"
                    name="email"
                    type="email"
                    id="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                  />                 
                </Form.Group>
                <PasswordInput
                  name="password"
                  id="password"
                  placeholder="Password"
                  value={this.state.password}
                  onChange={this.handleChange}
                />
                <div className='link_account'>
                  <Link to="/forgotpassword">Forgot password?</Link>
                </div>

                <Button variant="primary" type="submit">
                  Login
                </Button>
            </Form>
              
            </div>
            <div className='right_part'>
              <Testimonial />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (err) => dispatch(errorHandler.setError(err, { log: false })),
    login: (body) => dispatch(login(body)),
  };
};

export default connect(undefined, mapDispatchToProps)(Login);
